import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import * as Yup from "yup"; // For validation schema
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { telegramLogin, telegramVerifyOTP } from "../../../store/telegram/telegramThunk";

// Validation Schema
const phoneValidationSchema = Yup.object().shape({
  phone: Yup.string()
    .required("Phone number is required")
    .matches(/^\+?[1-9]\d{1,14}$/, "Enter a valid phone number"),

});

const LoginWithTelegram = ({ show6, handleClose6, setTgstep, Tgstep }) => {
  const [otp, setOtp] = useState(""); 
  const [phoneNumber, setPhoneNumber] = useState(null);
  let { telegramLoginloading, telegramLoginFullfill, telegramLoginError, telegramVerifyOTPError, telegramVerifyOTPloading, telegramVerifyOTPFullfill } = useSelector((state) => state.telegram);
  let Dispatch = useDispatch()
  useEffect(() => {
    if (telegramLoginFullfill !== null) {
      setTgstep(2);
    }
  }, [telegramLoginFullfill])
  useEffect(() => {
    if (telegramVerifyOTPFullfill !== null) {
      handleClose6()

    }
  }, [telegramVerifyOTPFullfill])

  const handlePhoneSubmit = (values) => {
    console.log("sss")
    if (Tgstep === 1) {
      setPhoneNumber(values.phone)
      Dispatch(telegramLogin(values.phone))
      console.log("Phone submitted: ", values.phone);

    }
  };
  const handleOtp = () => {
    if (Tgstep === 2) {
      let data = {
        phoneNumber: phoneNumber,
        code: otp,
        sessionString: telegramLoginFullfill?.sessionString
      }
      Dispatch(telegramVerifyOTP(data))
      alert("OTP verified successfully!");
    }
  }

  return (
    <Modal centered show={show6} onHide={handleClose6}>
      <Modal.Header closeButton>
        <Modal.Title className="h5">Telegram Login</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            phone: "+91", // Default value
            step: Tgstep,
          }}
          validationSchema={phoneValidationSchema}
          onSubmit={Tgstep == 2 ? handleOtp : handlePhoneSubmit}
          enableReinitialize
        >
          {({ setFieldValue, values }) => (
            <Form>
              {Tgstep === 1 ? (
                <div className="bg-white rounded-lg p-8 max-w-md m-auto">
                  <h2 className="text-xl font-bold text-center text-gray-800 mb-6">
                    Verify Your Phone Number
                  </h2>
                  <div className="d-flex justify-content-center">
                    <PhoneInput
                      country="in"
                      placeholder="Enter phone number"
                      value={values.phone}
                      onChange={(val) => setFieldValue("phone", val)}
                      autoFormat={true}
                    />
                  </div>
                  <ErrorMessage
                    name="phone"
                    component="div"
                    className="text-danger text-center mt-2"
                  />
                  <button type="submit" className="btn btn-primary w-full mt-4">
                    Verify Phone Number
                  </button>
                </div>
              ) : (
                <div className="bg-white rounded-lg p-8 max-w-md m-auto">
                  <h2 className="text-xl font-bold text-center text-gray-800 mb-6">
                    Verify Your OTP
                  </h2>
                  <p className="text-center text-gray-600 mb-4">
                    Enter the 5-digit OTP sent to your phone.
                  </p>
                  <div className="d-flex justify-content-center">
                    <OtpInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={5}
                      separator={<span style={{ width: "8px" }}></span>}
                      renderInput={(props) => <input {...props} />}
                      inputStyle={{
                        border: "1px solid transparent",
                        borderRadius: "8px",
                        width: "54px",
                        height: "54px",
                        fontSize: "12px",
                        color: "#000",
                        fontWeight: "400",
                        caretColor: "blue",
                        margin: "0px 5px",
                      }}
                      focusStyle={{
                        border: "1px solid #CFD3DB",
                        outline: "none",
                      }}
                    />
                  </div>
                  <ErrorMessage
                    name="otp"
                    component="div"
                    className="text-danger text-center mt-2"
                  />
                  <button type="submit" className="btn btn-primary w-full mt-4" >
                    Verify OTP
                  </button>
                </div>
              )}
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default LoginWithTelegram;
